import { makeCommonStore, FormField } from '../commons'
import BankAccountService from '@/services/BankAccountService.js'

const store = {
  ...makeCommonStore(
    {
      service: BankAccountService,
      fields: [
        new FormField({
          name: 'id',
          hidden: true
        }),
        new FormField({
          name: 'name',
          label: 'Account name *',
          icon: 'description',
          rules: [ 'required' ],
          md: 12
        }),
        new FormField({
          name: 'account_number',
          type: 'mask',
          label: 'Account number * (12-3456-7890123-000)',
          icon: 'payment',
          rules: [ 'required' ],
          mask: '##-####-#######-###',
          md: 12
        }),
        new FormField({
          name: 'bank',
          type: 'select',
          label: 'Bank',
          rules: [ 'required' ],
          items: [],
          icon: 'account_balance'
        }),
        new FormField({
          name: 'account_type',
          type: 'select',
          label: 'Account type',
          rules: [ 'required' ],
          items: [],
          icon: 'payment'
        }),
        new FormField({
          name: 'opening_balance',
          label: 'Initial balance',
          icon: 'attach_money'
        }),
        new FormField({
          name: 'balance_time',
          type: 'date',
          label: 'Balance time',
          value: ''
        })
      ]
    },
    ['fields']
  ),
  namespaced: true
}

store.mutations = {
  ...store.mutations,

  updateBankOptions (state, options) {
    state._data.fields[3].items = options
  },

  updateAccountTypeOptions (state, options) {
    state._data.fields[4].items = options
  }
}

store.actions = {
  ...store.actions,

  setBankOptions ({ commit, state }, data) {
    commit('updateBankOptions', data)
  },

  setAccountTypeOptions ({ commit, state }, data) {
    commit('updateAccountTypeOptions', data)
  }
}

export default store
